import { persistQueryClientNow, persistQueryClientSyncNow } from './persistNow';

/** Await a fresh dehydrate + persist (e.g. after offline queue mutation). */
export function flushPersistedQueryCache() {
  return persistQueryClientNow('flush');
}

/**
 * Synchronous persist for app background — runs before the OS suspends the WebView.
 * Always dehydrates the live cache; never replays a stale debounced buffer.
 */
export function flushPersistedQueryCacheSync(reason = 'background') {
  persistQueryClientSyncNow(reason);
  // Best-effort async native write; sync mirror already on disk via writeSync.
  void persistQueryClientNow(reason);
}
